import { bigintToFixed } from "rujira.js";

type OrderPrice = { type: string; deviation?: bigint | null; rate: bigint };

export const orderPriceKey = (order: OrderPrice) =>
  order.type === "oracle"
    // Zero deviation is valid; missing legacy data defensively means no offset.
    ? { oracle: Number(order.deviation ?? 0n) }
    : { fixed: bigintToFixed(order.rate) };

export const orderPriceSubscriptionKey = (order: OrderPrice) => {
  const price = orderPriceKey(order);
  return "oracle" in price
    ? `oracle:${price.oracle}`
    : `fixed:${price.fixed.replace(/\.?0+$/, "")}`;
};
